import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { appContentUrl, baseAppId } from 'settings';

const Row = props => {
  const { icon, children } = props;
  return (
    <div className="contactCard-Row-Container">
      <FontAwesomeIcon icon={icon} />
      <div>{children}</div>
    </div>
  );
};

const ContactCard = props => {
  const { name, role, options, img } = props;

  let PhoneRow = ({ obj }) => {
    return (
      <Row icon={['fas', 'phone']}>
        {obj.value} ({obj.label})
      </Row>
    );
  };
  let EmailRow = ({ obj }) => {
    return (
      <Row icon={['fas', 'at']}>
        <a href={`mailto:${obj.value}`}>{obj.value}</a>
      </Row>
    );
  };
  return (
    <div style={{ margin: 'auto' }}>
      <div className="contactCard-Container">
        <div className="contactCard_info">
          <div>
            <div>
              <h1>{name}</h1>
            </div>
            <div>
              <h6>{role}</h6>
            </div>
          </div>
          <div>
            {options.map(option => {
              if (option.type === 'tel') return <PhoneRow obj={option} key={option.value} />;
              if (option.type === 'email') return <EmailRow obj={option} key={option.value} />;
              return <Row>{option.value}</Row>;
            })}
          </div>
        </div>
        <div className="contactCard_imageContainer">
          <img
            src={img ? `${appContentUrl}${baseAppId}/${img}` : null}
            alt={img}
            className="contactCard_image"
            // height="130px"
            // width="130px"
          />
        </div>
      </div>
    </div>
  );
};

ContactCard.propTypes = {
  img: PropTypes.node,
  name: PropTypes.string,
  role: PropTypes.string,
  options: PropTypes.object
  // email: PropTypes.string,
  // phone: PropTypes.string,
  // address: PropTypes.shape({
  //   street: PropTypes.string,
  //   city: PropTypes.string,
  //   zip: PropTypes.string,
  // }),
};

export default ContactCard;
